import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Customer } from '../models/customer';
import {
    CustomerWithPendingDocumentsResponse,
    DriverSummary,
    Policy,
    Vehicle,
} from '../models/common-data-types';

@Injectable({
    providedIn: 'root',
})
export class CustomersService {
    constructor(private http: HttpClient) {}

    searchCustomer(searchPayload: any): Observable<any> {
        let params = new HttpParams();
        params = params
            .append('searchTerm', searchPayload['searchTerm'])
            .append('pageable', searchPayload['pageable']);
        return this.http.get('/admin/customers/search', { params });
    }

    fetchCustomerDetail(customerId: string): Observable<Customer> {
        return this.http.get<Customer>('/admin/customers/' + customerId);
    }

    fetchCustomerVehicles(customerId: string): Observable<Vehicle[]> {
        return this.http.get<Vehicle[]>(
            '/admin/customers/'.concat(customerId).concat('/vehicles')
        );
    }

    fetchCustomerPolicies(customerId: string): Observable<Policy[]> {
        return this.http.get<Policy[]>(
            '/admin/customers/'.concat(customerId).concat('/policies')
        );
    }

    fetchCustomerDrivers(customerId: string): Observable<DriverSummary[]> {
        return this.http.get<DriverSummary[]>(
            '/admin/customers/'.concat(customerId).concat('/drivers')
        );
    }

    fetchCustomersWithOutstandingDocuments(pageNumber: number, pageSize: number): Observable<CustomerWithPendingDocumentsResponse> {
        return this.http.get<CustomerWithPendingDocumentsResponse>(
            '/admin/customers/outstanding-documents?page='+pageNumber+'&size='+pageSize
        );
    }
}
